import React, {useEffect, useState} from "react";
import * as FunctionsValidation from "../../../Functions/FunctionsValidation";
import FunctionsData from "../../../Functions/FunctionsData";
import {TableCell, TableRow} from "@mui/material";
import moment from "moment/moment";
import StaffNZCARShowInfoRow from "./StaffNZCARShowInfoRow";
import StaffNZCARShowAction from "./StaffNZCARShowAction";

export default function StaffNZCARShowTableRow({row, setLoading})
{

    const [d, setD] = useState([]);
    const [openPayload, setOpenPayload] = useState([]);
    const [enabled, setEnabled] = useState(true);
    const [result, setResult] = useState('');
    const [btnName, setBtnName] = useState('Create NZCAR record');

    const [isError, setIsError] = useState(false);

    // const buttonEnabled = (String(window.location.host).includes('spcadesexingtest.nz') || String(window.location.host).includes('smartpol.co.nz'));
    const buttonEnabled = true;

    useEffect(() => {

        try {
            console.log(FunctionsValidation.ValidatePhoneNumberNZ(row.phone))
            setIsError(FunctionsValidation.ValidatePhoneNumberNZ(row.phone));
        } catch (e) {
            console.log(e)
        }

        let res = [];
        for (let x in row) {
            res.push(row[x])
        }

        setD(res);

    }, []);

    function postData() {
        setEnabled(false);
        //console.log('/api/integration/nzcar/api/' + row.order_voucher_id, row.payload);
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/integration/nzcar/api/') + row.order_voucher_id,
            row.payload
        ).then((r) => {
            //console.log('/api/integration/nzcar/api/' + row.order_voucher_id, r);
            setResult(JSON.stringify(r));
            setBtnName(r.data.status);
            setEnabled(true);
            setLoading(true);
        });

    }

    function postDataManually() {
        setEnabled(false);
        console.log(row.payload);
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/integration/nzcar/manualfix/') + row.order_voucher_id,
            JSON.parse(row.payload)
        ).then((r) => {
            //console.log('/api/integration/nzcar/manualfix/' + row.order_voucher_id, r);
            setResult(JSON.stringify(r));
            setBtnName('Completed');
            setEnabled(true);
            setLoading(true);
        });

    }

    return (
        <TableRow>
            <TableCell align="left">{row.animal_microchip}</TableCell>
            <TableCell align="left">{row.microchip_type}</TableCell>
            <TableCell align="left">{row.animal_type}</TableCell>
            <TableCell align="left">{row.owner_first_name} {row.owner_last_name}</TableCell>
            <TableCell align="left">{row.vet_business_name}</TableCell>
            <TableCell align="left">{moment(row.animal_date_surgery).format('DD/MM/YYYY')}</TableCell>
            <TableCell>
                <StaffNZCARShowInfoRow {...{row, setLoading}} setOpenPayload={setOpenPayload} openPayload={openPayload}/>
            </TableCell>
            <TableCell>
                <StaffNZCARShowAction {...{row, setLoading}} key={Date.now()}
                                      buttonEnabled={buttonEnabled} btnName={btnName}
                                      setOpenPayload={setOpenPayload} openPayload={openPayload} enabled={enabled}
                                      postData={postData} postDataManually={postDataManually}/>
            </TableCell>
        </TableRow>
    )
}
